import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import "../CSS/Grids.css"

export default function GridsUBS(props) { 

  const [gridsToDraw, setGridsToDraw] = useState([]);
  const [underbodyImage, setUnderBodyImage] = useState("");
  const [rearParts, setRearparts] = useState("");
  useEffect(() => {}, [props.underbodyImage]);

  useEffect(() => { 
    setUnderBodyImage(props.underbodyImage);
    let model = props.model;
    const rearPar = props.rear
    if (model === "Z101") {
      
      const dataZ101 = Array.from({ length: 7 }, () =>
        Array.from({ length: 12 },() => " ")
      );  
      setGridsToDraw(dataZ101);
    } else if (model === "W601") {
      setUnderBodyImage(true);
      const dataW601 = Array.from({ length: 9 }, () =>
        Array.from({ length: 12 },() => " ")
      );
      setGridsToDraw(dataW601);
    }
    else if (rearPar === "Z101") {
      setRearparts(true);
      const dataZ101 = Array.from({ length: 6 }, () =>
        Array.from({ length: 10 }, () => " ")
      );
      setGridsToDraw(dataZ101);
    }
    
    else {
      const data = Array.from({ length: 6 }, () =>
        Array.from({ length: 9 }, () => " ")
      );
      setGridsToDraw(data);
    }
  }, [props.underbodyImage]);

  const highlightedCell = Array.from(props.highlightedCells || []);

  const highlightedCells = highlightedCell.map((grid) => ({
    row: grid.row,
    col: grid.column,
  }));

  return (
    <> 
      {underbodyImage === true ? (
        <>
          {gridsToDraw.map((row, rowIndex) => (
            
              <Row key={rowIndex} className="row_height_ubs_underbody">
                {row.map((cell, colIndex) => (
                  <Col
                    key={colIndex}
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    xxl={1}
                    className={
                      highlightedCells.some(
                        (highlightedCell) =>
                          highlightedCell.row === rowIndex &&
                          highlightedCell.col === colIndex
                      )
                        ? "highlighted"
                        : ""
                    }
                  >
                    <div className="modified_row "> {cell} </div>
                  </Col>
                ))}
              </Row> 
          ))}
        </>
      ) : (
        <>
          {gridsToDraw.map((row, rowIndex) => (
            <Row key={rowIndex} className="row_height_ubs">
              {row.map((cell, colIndex) => (
                <Col
                  key={colIndex}
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  xl={1}
                  xxl={1}
                  className={
                    highlightedCells.some(
                      (highlightedCell) =>
                        highlightedCell.row === rowIndex &&
                        highlightedCell.col === colIndex
                    )
                      ? "highlighted"
                      : ""
                  }
                >
                  <div className="modified_row "> {cell} </div>
                </Col>
              ))}
            </Row>
          ))}
        </>
      )}
    </>
  );
}